import { render, staticRenderFns } from "./TournamentDetailsModal.vue?vue&type=template&id=431bed75"
import script from "./TournamentDetailsModal.vue?vue&type=script&lang=js"
export * from "./TournamentDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./TournamentDetailsModal.vue?vue&type=style&index=0&id=431bed75&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports